/**
 * modules.ts — YAGNI module keys and types
 *
 * MODULE_KEYS is the canonical list of all module identifiers in v1.
 * Each module owns a FAB icon, a Pulse surface, and a drawer view.
 *
 * Spec: docs/superpowers/specs/2026-05-01-yagni-hybrid-pivot-design.md §4.2, §4.4
 */
// ---------------------------------------------------------------------------
// Key arrays
// ---------------------------------------------------------------------------
export const YAGNI_MODULE_KEYS = [
    "yagni_pulse_chat",
    "yagni_channels",
    "yagni_work",
    "yagni_knowledge",
    "yagni_vision",
    "yagni_rhythms",
    "yagni_runs",
    "yagni_crm",
];
export const CONNECTOR_MODULE_KEYS = [
    "slack",
    "gmail",
    "gcal",
    "google_drive",
    "linear",
    "jira",
    "hubspot",
    "notion",
    "github",
];
export const MODULE_KEYS = [
    ...YAGNI_MODULE_KEYS,
    ...CONNECTOR_MODULE_KEYS,
];
// ---------------------------------------------------------------------------
// Module groups
// ---------------------------------------------------------------------------
export const MODULE_GROUPS = {
    yagni: YAGNI_MODULE_KEYS,
    connector: CONNECTOR_MODULE_KEYS,
};
// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
/**
 * Type guard: returns true if `s` is a known static ModuleKey or an
 * mcp:-prefixed dynamic key.
 */
export function isModuleKey(s) {
    return MODULE_KEYS.includes(s) || s.startsWith("mcp:");
}
/**
 * Returns the group a ModuleKey belongs to.
 * MCP modules are their own group since they are dynamically registered.
 */
export function moduleGroup(key) {
    if (typeof key === "string" && key.startsWith("mcp:"))
        return "mcp";
    if (YAGNI_MODULE_KEYS.includes(key))
        return "yagni";
    return "connector";
}
//# sourceMappingURL=modules.js.map